import { ComponentHeader, StyledTermPage } from "@components";
import { useTranslation } from "react-i18next";

export const PagePrivacy = () => {
  const { t } = useTranslation();
  return (
    <>
      <ComponentHeader title={t("page.privacy_policy")} />
      <StyledTermPage>
        <p>Privacy Policy</p>
        <p>Privacy Policy for HIMNCH Digital System</p>

        <p>
          At HIMNCH Digital System, we are committed to protecting the privacy and security of your
          personal information. This Privacy Policy outlines how we collect, use, disclose, and
          safeguard your information when you use our digital system. Please read this policy
          carefully to understand our practices regarding your information and how we will treat it.
          By using the HIMNCH Digital System, you agree to the terms of this Privacy Policy.
        </p>

        <p>Information We Collect</p>
        <p>1.1 Personal Information:</p>
        <p>
          We may collect personal information that you provide directly to us when you use our
          digital system. This includes information such as your name, contact details, township
          address, and other personally identifiable information necessary to provide the services
          including service utilization history.
        </p>
        <p>1.2 Usage Information:</p>
        <p>
          We automatically collect certain information about your interaction with our digital
          system. This includes your IP address, device information, browser type, and operating
          system. This information is collected using cookies and similar tracking technologies.
        </p>
        <p>Use of Information</p>
        <p>2.1 Provision of Services:</p>
        <p>
          We use the information we collect to provide, maintain, and improve the functionality of
          the HIMNCH Digital System. This includes processing your requests, communicating with you,
          and personalizing your experience.
        </p>
        <p>2.2 Analytics and Performance:</p>
        <p>
          We may use the collected information to analyze usage patterns, monitor and improve the
          performance of our digital system, and conduct research to enhance our services.
        </p>
        <p>2.3 Communication:</p>
        <p>
          We may use your information to send you administrative notifications, updates, and other
          relevant communications regarding the HIMNCH Digital System.
        </p>
        <p>2.4 Legal Compliance:</p>
        <p>
          We may use your information to comply with applicable laws, regulations, legal processes,
          or enforceable governmental requests.
        </p>
        <p>Sharing of Information</p>
        <p>3.1 Service Providers:</p>
        <p>
          We may share your information with third-party service providers who perform services on
          our behalf, such as hosting, data analysis, customer support, and other related services.
          These service providers are bound by confidentiality agreements and are prohibited from
          using your information for any other purposes.
        </p>
        <p>3.2 Aggregated or Anonymized Data:</p>
        <p>
          We may aggregate or anonymize your information to create statistical or demographic data
          that cannot be linked back to you. This aggregated or anonymized data may be used for
          research, analytics, marketing, or other lawful purposes.
        </p>
        <p>3.3 Legal Requirements:</p>
        <p>
          We may disclose your information if required to do so by law or in response to valid
          requests by public authorities (e.g., government or law enforcement agencies).
        </p>
        <p>Data Security</p>
        <p>
          We implement appropriate technical and organizational measures to protect your information
          against unauthorized access, alteration, disclosure, or destruction. However, please note
          that no data transmission or storage system can be guaranteed to be 100% secure.
        </p>
        <p>Your Choices and Rights</p>
        <p>5.1 Access and Update:</p>
        <p>
          You have the right to access, update, and correct your personal information held by HIMNCH
          Digital System. You can do this by contacting us using the information provided in the
          &quot;Contact Us&quot; section below.
        </p>
        <p>5.2 Opt-Out:</p>
        <p>
          You have the right to opt-out of receiving promotional emails or marketing communications
          from us. You can unsubscribe by following the instructions provided in the email or
          contacting us using the information provided below.
        </p>
        <p>Changes to This Privacy Policy</p>
        <p>
          We may update this Privacy Policy from time to time to reflect changes in our practices or
          legal requirements. We will notify you of any material changes by posting the updated
          policy on our digital system and updating the &quot;Effective Date&quot; at the top of the
          policy.
        </p>
        <p>Contact Us</p>
        <p>
          If you have any questions, concerns, or requests regarding this Privacy Policy or the
          privacy practices of HIMNCH Digital System, please contact us at:
        </p>
        <p>[Contact Information]</p>
        <p>We will strive to address your inquiries in a timely and appropriate manner.</p>
        <p>By using the HIMNCH</p>
      </StyledTermPage>
    </>
  );
};
